export const SENTRY_AXIOS = 'APP_AXIOS';
export const SENTRY_APP = 'APP';
export const SENTRY_ANALYTIC = 'ANALYTIC';
export const SUBSCRIPTION_ACTION = 'SUBSCRIPTION_ACTION';
export const DEEP_LINK_ERROR = 'DEEP_LINK_ERROR';

export const IOS = 'iOS';
export const ANDROID = 'Android';
export const CHROME = 'Chrome';
export const IOS_MIN_VERSION = 14.3;
export const ANDROID_MIN_VERSION = 7;
export const CHROME_MIN_VERSION = 59;

export const WIDTH_SIZE = 2000;
export const HEIGHT_SIZE = 2000;

export const SENTRY_CABINET = 'CABINET';

export const IGNORE_URLS_LIST = [
    // Facebook flakiness
    /graph\.facebook\.com/i,
    // Facebook blocked
    /connect\.facebook\.net\/en_US\/all\.js/i,
    // Woopra flakiness
    /eatdifferent\.com\.woopra-ns\.com/i,
    /static\.woopra\.com\/js\/woopra\.js/i,
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
    // Other plugins
    /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
    /webappstoolbarba\.texthelp\.com\//i,
    /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
];

export const IGNORE_ERRORS_LIST = [
    // Network errors such as going offline or being blocked by a proxy
    /.*Failed to fetch.*/g,
    /.*Network Error.*/g,
    /.*Load failed.*/g,

    // Random plugins/extensions
    'top.GLOBALS',
    // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
    'originalCreateNotification',
    'canvas.contentDocument',
    'MyApp_RemoveAllHighlights',
    'http://tt.epicplay.com',
    "Can't find variable: ZiteReader",
    'jigsaw is not defined',
    'ComboSearch is not defined',
    'http://loading.retry.widdit.com/',
    'atomicFindClose',
    // Facebook borked
    'fb_xd_fragment',
    // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
    // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
    'bmi_SafeAddOnload',
    'EBCallBackMessageReceived',
    // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
    'conduitPage',

    /.*e.extra.agent.*/g,
    /.*timeout of 10000ms exceeded.*/g,
    /.*undefined is not an object (evaluating 't.default').*/g,
    /.*Cannot find module.*/g,
    /.*OneTrust: Invalid domain id.*/g,
    /.*Required token is missing.*/g,
    /.*Token Required.*/g,
    /.*code 409.*/g,
    /.*code 400.*/g,
    /.*Suspected Fraud.*/g,
    /.*Failed to execute 'insertBefore'.*/g,
    /.*__AutoFillPopupClose__.*/g,

    // solidSdk: PayPal button error (close payPal popup)
    /.*isTrusted.*/g,

    /.*undefined is not an object (evaluating 'r.DomainData').*/g,
    /.*null is not an object (evaluating 'this.selector.appendChild').*/g,
    /.*The object can not be found here.*/g,
    /.*undefined is not an object (evaluating 'e.Domain').*/g,
    /.*The object can not be cloned.*/g,
    /.*window.Zeit.setFontSize.*/g,
    /.*Can't find variable: iom.*/g,

    /.*InvalidSignatureException.*/g,
    /.*totalRetryDelay.*/g,
    /.*Can't find variable: stopYouTubeVideos.*/g,
    /.*Window closed for postrobot_method before ack.*/g,
    /.*Can't find variable: clickPauseText2SpeechButton.*/g,
    /.*Right side of assignment cannot be destructured.*/g,
    /.*Data Collector must be created with Kount and\/or PayPal.*/g,
    /.*Can't find variable: PaymentAutofillConfig.*/g,
    /.*null is not an object (evaluating 'document.getElementById('taboola_ad_script').getBoundingClientRect').*/g,
    /.*undefined is not an object (evaluating 't.Domain')*/g,
    /.*undefined is not an object (evaluating 'n.length')*/g,
    /.*Cannot read properties of undefined (reading 'domInteractive')*/g,

    // DuckDuckGo mobile 7 postMessage error
    'WKWebView API client did not respond to this postMessage',

    // Solid SDK Console Error after switching products on payment screen
    /.*Payment form iframe was removed from DOM before initialization ended*/g,

    // An error on all projects in solid-form
    /.*The object does not support the operation or argument.*/g,

    // Error from Sentry itself
    /.*Can't find variable: msDiscoverChatAvailable*/g,
];

export const BLACK_LIST_HANDLED_ERROR_NAMES = [
    'InvalidSignatureException',
    'totalRetryDelay',
    'timeout of 10000ms exceeded',
    "Can't find variable: iom",
    "Can't find variable: stopYouTubeVideos",
    'Window closed for postrobot_method before ack',
    "Can't find variable: clickPauseText2SpeechButton",
    'Right side of assignment cannot be destructured',
    'The object can not be cloned.',
    "undefined is not an object (evaluating 't.default')",
    'Data Collector must be created with Kount and/or PayPal.',
    "Can't find variable: PaymentAutofillConfig",
    "null is not an object (evaluating 'document.getElementById('taboola_ad_script').getBoundingClientRect')",
    "undefined is not an object (evaluating 't.Domain')",
    "undefined is not an object (evaluating 'n.length')",
];

export const BLACK_LIST_HANDLED_ERROR_NAMES_LOCAL = [
    ...BLACK_LIST_HANDLED_ERROR_NAMES,
    "undefined is not an object (evaluating 'this.socket.unsubscribe')",
    "Cannot read properties of undefined (reading 'Domain')",
];

export const IGNORE_ERRORS_LIST_LOCAL = [
    ...IGNORE_ERRORS_LIST,
    "Can't find variable: __AutoFillPopupClose__",
    /.*Non-Error promise rejection captured'.*/g,
];
